import { Tabs, Tab } from '@mui/material';

const HeaderTabs = ({ tabValue, handleTabChange, labels }) => {
  return (
    <Tabs
      value={tabValue}
      onChange={handleTabChange}
      sx={{
        borderBottom: '1px solid #e0e0e0',
        '& .MuiTabs-indicator': {},
        '& .MuiTab-root': {
          fontSize: '1.1rem',
          padding: '12px 24px',
          transition: 'background-color 0.3s ease',
        },
        '& .MuiTab-root:hover': {
          backgroundColor: '#f5f5f5',
        },
      }}
    >
      {/* <Tab label="אישור הזמנות" />
      <Tab label="היסטורית אישורים" /> */}     
       {labels.map((label, index) => (
        <Tab key={index} label={label} />
      ))}
    </Tabs>
  );
};

export default HeaderTabs;
